import React, { useEffect, useRef, useState } from "react";
import { ArrowUpRight, X, LogOut, ChevronRight } from "lucide-react";

export default function MobileNavigation({ groups, auditPanel, displayName, role, pathname, go, onClose, onLogout }) {
  const [selected, setSelected] = useState("overview");
  const panelRef = useRef(null);
  const closeRef = useRef(null);
  const group = groups.find(item => item.id === selected) || groups[0];

  useEffect(() => {
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    closeRef.current?.focus();
    const onKey = event => {
      if (event.key === "Escape") { event.preventDefault(); onClose(); }
      if (event.key !== "Tab") return;
      const controls = [...panelRef.current.querySelectorAll('button:not([disabled]), a[href], input, [tabindex="0"]')].filter(node => node.getClientRects().length);
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    };
    const desktop = window.matchMedia("(min-width: 1601px)");
    const onResize = event => { if (event.matches) onClose(); };
    document.addEventListener("keydown", onKey);
    desktop.addEventListener("change", onResize);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", onKey);
      desktop.removeEventListener("change", onResize);
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, [onClose]);

  return <div className="workspace-menu">
    <div className="workspace-menu__backdrop" onClick={onClose} aria-hidden="true" />
    <section id="workspace-navigation" className="workspace-menu__panel" ref={panelRef} role="dialog" aria-modal="true" aria-labelledby="workspace-menu-title">
      <header className="workspace-menu__header">
        <div><span className="workspace-menu__eyebrow">TUKUZA · YOUR WORKSPACE</span><h2 id="workspace-menu-title">Where to next<span>?</span></h2><p>Small steps. Better every day.</p></div>
        <button ref={closeRef} className="workspace-menu__close" onClick={onClose} aria-label="Close menu"><X size={22} /></button>
      </header>
      <div className="workspace-menu__body">
        <nav className="workspace-menu__categories" aria-label="Navigation categories">
          {groups.map(item => <button key={item.id} onClick={() => setSelected(item.id)} aria-pressed={group.id === item.id} aria-controls="workspace-menu-content" className={group.id === item.id ? "is-selected" : ""}>
            <span className="workspace-menu__category-icon">{item.icon}</span><span>{item.label}</span><ChevronRight size={14} className="workspace-menu__chevron" />
          </button>)}
        </nav>
        <div className="workspace-menu__content" id="workspace-menu-content">
          <div className="workspace-menu__section-heading"><span>{group.label}</span><p>{group.description}</p></div>
          {group.id === "audits" ? auditPanel : <div className="workspace-menu__links">
            {group.links.map(link => <button key={link.path} onClick={() => go(link.path)} aria-current={pathname === link.path ? "page" : undefined}>
              <span className="workspace-menu__link-icon">{link.icon || group.icon}</span><span><strong>{link.label}</strong><small>{link.description}</small></span><ArrowUpRight size={17} />
            </button>)}
          </div>}
        </div>
      </div>
      <footer className="workspace-menu__footer"><div className="workspace-menu__identity"><span>{displayName.slice(0, 1).toUpperCase()}</span><div><strong>{displayName}</strong><small>{role || "Team member"}</small></div></div><button onClick={onLogout}><LogOut size={17} /> Sign out</button></footer>
    </section>
  </div>;
}
